<template>
    <div id="referalLandingDiv">
        <HeaderVue  isHeader="true"/>
        <div class="loading">
            <div class="loading-img">
                <img src="static/images/walk.gif" alt="">
            </div>
        </div>
        <div class="credit-section">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-4  cr-left">
                        <h3>Your Credit</h3>
                        <h2>Rs.{{creditPoint}}</h2>
                        <router-link to="/lab"><button type="button" class="btn btn-primary">USE NOW</button></router-link>
                    </div>
                    <div class="col-sm-8">
                        <div class="cr-content">
                            
                            <h2>Refer Now </h2>
                            <div class="cr-code"><h5 v-if=" this.referralCode">{{referralCode}}</h5></div>
                            <div class="cr-cod-con">
                                    <p>{{description}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="inline-img">
            <div>
                <img src="static/images/book1.png" alt="">                
            </div>
            <div>
                <img src="static/images/book3.png" alt="">                
            </div>
        </div> -->
        <div class="wraper-mob">
            <h2><router-link to="/referral/invite">Refer Now</router-link></h2>
            <div class="container">
                <div class="row">
                    <div class="cr-mob">
                        <div class="col-sm-12 ">
                            <a href="/redirect/labs/Dengue_Profile"><img src="static/images/book-mob3.png" alt=""></a>
                        </div>
                        <div class="col-sm-12 ">
                            <img src="static/images/book-mob4.png" alt="">
                        </div>
                    </div>
                   <div class="cr-mob">
                        <div class="col-sm-12 ">
                            <a href="/redirect/labs/Mega_Health_Checkup"><img src="static/images/book-mob1.png" alt=""></a>
                        </div>
                        <div class="col-sm-12 ">
                            <img src="static/images/book-mob2.png" alt="">
                        </div>
                   </div>
                </div>
            </div>
        </div>
        <!-- credit-section_end -->
        <div class="container">
            <div class="row mt-3">
                <div class="col-sm-12">
                    <h2 class="section-title text-center">Our Lab Partners</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div id="carouselLabPartners" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img src="static/images/client/medall.jpg" class="d-block w-75 align-center" alt="Medall Health Care Pvt Ltd">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/metroplis.png" class="d-block w-75 align-center" alt="Lister Metropolis Healthcare Limited">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/bioline.jpg" class="d-block w-75 align-center" alt="Bio Line Laboratory">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/techmed.jpg" class="d-block w-75 align-center" alt="Techmed Health Centre & Diagnostic">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/srl.png" class="d-block w-75 align-center" alt="Specialtys Medical Diagnostic(SRL Diagnostics)">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/vrr.jpg" class="d-block w-75 align-center" alt="VRR Diagnostics">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/medcis.png" class="d-block w-75 align-center" alt="Medcis Pathlabs India Pvt. Ltd">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/pathcare.jpg" class="d-block w-75 align-center" alt="Path Care Labs Pvt. Ltd">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/aarthi.jpg" class="d-block w-75 align-center" alt="Aarthi Scans And Labs">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/primex.png" class="d-block w-75 align-center" alt="Primex Scans and Labs">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/microbiological.jpg" class="d-block w-75 align-center" alt="Microbiological Laboratory">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/hitech.jpg" class="d-block w-75 align-center" alt="Hitech Diagnostic Centre">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/asian.jpg" class="d-block w-75 align-center" alt="Asian Diagnostics">
                            </div>
                            <div class="carousel-item">
                                <img src="static/images/client/diagnolabs.jpg" class="d-block w-75 align-center" alt="Diagno labs Pvt Ltd">
                            </div>
                        </div>
                        <a class="carousel-control-prev" href="#carouselLabPartners" role="button" data-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"><i class="fa fa-angle-double-left"></i></span>
                            <span class="sr-only">Previous</span>
                        </a>
                        <a class="carousel-control-next" href="#carouselLabPartners" role="button" data-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"><i class="fa fa-angle-double-right"></i></span>
                            <span class="sr-only">Next</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- <FooterVue /> -->
    </div>
</template>
<script>
// import Vue from "vue";
import HeaderVue from "@/components/mobile/Header";
// import FooterVue from "@/components/web/Footer";
import _ from 'underscore'
export default {
  name: "ReferralLanding",
  components: {
    HeaderVue
    // FooterVue
  },
  mounted () {
      this.getProfile()
  },
  beforeCreate() {},
  created() {
    // this.getProfile()
    setTimeout(function () {
        $('.slider').bxSlider({
            slideWidth: 'auto',
            minSlides: 1,
            maxSlides: 6,
            moveSlides: 6,
            slideMargin: 10,
            auto: true,
            autoControls: true
        })
        $("#carouselExampleControls").carousel()
        var footHeight = $('.fixed-footer').outerHeight()
        $('body').css('margin-bottom', footHeight)
    }, 100)
  },
  data() {
    return {
      referralCode : '',
      referralUrl : 'https://labotist.com/',
      title : 'Labotist - Referral Program',
      quote : 'Hi, \r\n Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
      description : 'Hi,  \r\n  Here is the referral link to register with Labotist.com. They provide home blood test service and on registering you will get a credit of Rs 150 which you can use against your bookings with them, for blood test at home. \r\n   Labotists offers over 1000+ tests in partnership with 50 labs in Bengaluru and Chennai.',
      hashtags : 'Labotist,free blood sample collection,',
      twitterUser : 'Labotist.com'
    }
  },
  methods: {
    getProfile: function () {
        try {
            if (this.$localStorage.get('loggedIn') && this.$localStorage.get('access_token') && this.$localStorage.get('access_token') !== null) {
                var data = {}
                Promise.resolve(this.$GET('patient/getProfile', data)).then(function (res) {
                    if (res.response_code === 0) {
                    if (res.response) {
                        _.each(res.response.Addresses, function (item) {
                        if (item.isDefault === 1) {
                            this.address = item.address
                        }
                        })
                    }
                    console.log("inside the process")
                    console.log(res.response)
                    this.firstName = res.response.Patient.firstName
                    this.lastName = res.response.Patient.lastName
                    this.email = res.response.email
                    this.phone1 = res.response.Patient.phone1
                    this.phone2 = res.response.Patient.phone2
                    this.dob = res.response.Patient.dob ? res.response.Patient.dob : ''
                    this.sex = res.response.Patient.sex
                    this.creditPoint = res.response.Patient.creditPoint
                    this.referralCode = res.response.Patient.referralCode
                    console.log(this.referralCode)
                    this.referralUrl = this.$signupUrl + this.$encryptString(this.referralCode)
                    this.credits = res.response.credits
                    }
                    this.$hidePageLoading()
                }.bind(this)).catch(function (err) {
                    console.error(err)
                })
            }
        } catch (e) {
            console.error('method:getProfile', e)
        }
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/mobile/Public/ReferralLanding.vue